import basePluralize from 'pluralize';

//pluralize packages doesn't respect the casing of the replacement word
export const pluralRules: Record<string, string> = { GP: 'GPs' };

export const pluralizeWithRules = (word: string, count?: number, inclusive?: boolean): string => {
  if ((!count || count === 0 || count > 1) && word in pluralRules) {
    return (inclusive ? count + ' ' : '') + pluralRules[word];
  }

  return basePluralize(word, count, inclusive);
};

export const pluralize = pluralizeWithRules;
